import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { whyUsPoints } from '@/constants/company'

export function WhyUsSection() {
  return (
    <Section surface="0">
      <Container>
        <div className="max-w-2xl mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-fg">
            Built on Principles
          </h2>
          <p className="mt-2.5 sm:mt-3 text-sm sm:text-base text-fg-subtle">
            We reject cut corners and short-term workarounds. Our philosophy centers on architectural integrity and complete client autonomy.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-6 md:gap-10">
          {whyUsPoints.map((point, index) => (
            <div key={point.id} className="flex flex-col border-t border-border-subtle pt-3.5 sm:pt-6">
              <span className="font-mono text-[11px] sm:text-xs text-fg-muted mb-1.5 sm:mb-3">
                0{index + 1}
              </span>
              <h3 className="text-sm sm:text-base md:text-lg font-semibold text-fg tracking-tight mb-1 sm:mb-2">
                {point.title}
              </h3>
              <p className="text-xs sm:text-sm text-fg-subtle leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>
      </Container>
    </Section>
  )
}
